<template>
  <div class="jade-dropdown-selection">
    <JadeDropdown
      :open="isOpen"
      :allowedPlacements="allowedPlacements"
      @toggleOpen="toggleOpen"
      @closePopover="closePopover"
    >
      <template #trigger>
        <div
          class="jade-dropdown-selection__trigger"
          data-testid="dropdown-selection-trigger"
        >
          <slot name="trigger" />
        </div>
      </template>
      <template>
        <div class="jade-dropdown-selection__header flex justify-between p-4">
          <jade-text
            color="high"
            weight="bold"
            variant="text-large"
          >
            {{ title || 'Selecione uma opção' }}
          </jade-text>
          <button
            class="jade-dropdown-selection__close"
            @click="onCancel"
          >
            <jade-text
              color="current-color"
              weight="medium"
              variant="text-medium"
            >
              Cancelar
            </jade-text>
          </button>
        </div>

        <JadeDivider />
        <div
          class="jade-dropdown-selection__search-wrapper"
          data-testid="dropdown-selection-search"
        >
          <JadeInputField
            v-if="searchable"
            :value.sync="searchValue"
            placeholder="Busque por uma opção"
            :leadingItem="{ type: 'icon', content: 'action-search' }"
            label=""
          >
          </JadeInputField>
        </div>
        <div
          class="jade-dropdown-selection__content"
          data-testid="dropdown-selection-content"
        >
          <JadeListItemSelection
            :options="filteredOptions || internalOptions"
            :type="type"
            @onOptionChange="onOptionChange"
          >
          </JadeListItemSelection>
        </div>
        <JadeDivider />
        <div class="jade-dropdown-selection__trailing">
          <slot name="trailing" />
        </div>
        <JadeDivider />
        <div class="jade-selection__footer p-4">
          <JadeButtonGroup
            direction="horizontal"
            expanded
          >
            <template v-slot:default="{ size }">
              <JadeButton
                @click="onApply"
                variant="primary-solid"
                :size="size"
              >
                Aplicar
              </JadeButton>

              <JadeButton
                :size="size"
                @click="onClear"
              >
                Limpar
              </JadeButton>
            </template>
          </JadeButtonGroup>
        </div>
      </template>
    </JadeDropdown>
  </div>
</template>
<script>
import JadeInputField from '@jade/JadeInputField'
import JadeDropdown from '@jade/JadeDropdown'
import JadeText from '@jade/JadeText'
import JadeDivider from '@jade/JadeDivider'
import JadeListItemSelection from '@jade/JadeListItemSelection'
import JadeButtonGroup from '@jade/JadeButtonGroup'
import JadeButton from '@jade/JadeButton'

import { TYPE_ENUM, isSingle } from '../enums/dropdown-selection-type.enum.js'

export default {
  name: 'JadeDropdownSelection',
  components: {
    JadeDropdown,
    JadeInputField,
    JadeDivider,
    JadeText,
    JadeListItemSelection,
    JadeButtonGroup,
    JadeButton
  },
  data () {
    return {
      searchValue: '',
      isOpen: false,
      internalOptions: [],
      selectedOption: undefined
    }
  },
  props: {
    searchable: Boolean,
    title: String,
    options: Array,
    type: {
      type: String,
      required: true,
      validation: t => [TYPE_ENUM.SINGLE, TYPE_ENUM.MULTI].includes(t)
    },
    open: Boolean,
    allowedPlacements: Array
  },
  computed: {
    filteredOptions () {
      return this.internalOptions.filter(option =>
        option.label?.toLowerCase().includes(this.searchValue.toLowerCase())
      )
    },
    selectedOptions () {
      return this.internalOptions.filter(option => option.selected)
    }
  },
  watch: {
    options: {
      handler (options) {
        this.internalOptions = options
      },
      deep: true,
      immediate: true
    },
    open (open) {
      this.isOpen = open
    }
  },
  methods: {
    onOptionChange (option) {
      if (isSingle(this.type)) {
        const { label, value } = option
        const selectedOption = { label, value }
        this.selectedOption = selectedOption
        return this.$emit('onOptionChange', selectedOption)
      }

      const tempArray = this.internalOptions
      const item = tempArray.find(item => item.value === option.value)
      const indexOf = tempArray.indexOf(item)
      tempArray[indexOf].selected = option.selected

      this.internalOptions = tempArray
      this.$emit('onOptionChange', option)
    },
    onApply () {
      this.$emit(
        'onApply',
        isSingle(this.type) ? this.selectedOption : this.selectedOptions
      )
      this.closePopover()
    },
    onCancel () {
      this.$emit('onCancel')
      this.closePopover()
    },
    onClear () {
      this.resetState()
      this.$emit('onClear')
      this.closePopover()
    },
    resetState () {
      this.internalOptions = this.internalOptions.map(option => ({
        ...option,
        selected: false
      }))
      this.selectedOption = undefined
    },
    toggleOpen (value) {
      this.isOpen = !!value
      this.$emit('toggleOpen', !!value)
    },
    closePopover () {
      this.isOpen = false
      this.$emit('closePopover')
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/dropdown-selection.css';
</style>
